// import { useEffect } from "react";
// import lottie from "lottie-web";
// import { GENERAL_ANIMATIONS } from "../../utils";
import GenericMenu from "../../Shared Components/genericMenu";

export default function HeaderMenuItems({ headerAnimationRef }) {
    
  // useEffect(() => {
  //   if (headerAnimationRef && headerAnimationRef?.current) {
  //     lottie.destroy("Header Animation");
  //     lottie.loadAnimation({
  //       container: headerAnimationRef.current,
  //       renderer: "svg",
  //       loop: true,
  //       autoplay: true,
  //       name: "Header Animation",
  //       animationData: GENERAL_ANIMATIONS.live,
  //     });
  //   }
  // }, []);

  const menuItems = [
    {
      name: "Problems",
      url: "/explore",
      id: "header_1",
    },
    {
      name: "Courses",
      url: "/courses",
      id: "header_2",
      // extra: {
      //   name: "Sale",
      //   backgroundColor: "#FF923D",
      // },
      // submenu: [
      //   {
      //     name: "Summer SkillUp",
      //     url: "/courses/summer-skillup-sessions-2023",
      //     id: "header_courses_sss",
      //   },
      //   {
      //     name: "All Courses",
      //     url: "/courses",
      //     id: "header_allcourses",
      //   },
      // ],
    },
    // {
    //   name: "Geek-O-Lympics",
    //   url: "https://www.geeksforgeeks.org/geek-olympics-2023",
    //   id: "header_3",
    //   nameColor: "rgb(255 112 0)",
    // },
    {
      name: "Jobs",
      url: "https://www.geeksforgeeks.org/jobs",
      id: "header_3",
    },
    {
      name: "Events",
      url: "/events",
      id: "header_4",
      // nameColor: "rgb(255 112 0)",
      // extra: {
      //   name: "Upcoming",
      //   backgroundColor: "#f4aa3a",
      // },
      animation: {
        ref: headerAnimationRef,
      },
      submenu: [
        {
          name: "GFG Weekly Coding Contest",
          url: "/events/rec/gfg-weekly-coding-contest",
          id: "header_contest_weeklycode",
        },
        {
          name: "Job-a-Thon",
          url: "/events/rec/job-a-thon",
          id: "header_contest_jobathon",
          hideSelected: true,
        },
        // {
        //   name: "Hack-a-thon",
        //   url: "/hackathon/geek-o-lympic-hackathon",
        //   id: "header_contest_hackathon",
        // },
        // {
        //   name: "BiWizard School Contest",
        //   url: "/events/rec/step-up-coding-school",
        //   id: "header_contest_biwizard",
        // },
        // {
        //   name: "Prepare for GATE 2024",
        //   url: "/events/rec/aim-for-gate",
        //   id: "header_contest_promoevent1",
        // },
        // {
        //   name: "Solving for India Hack-a-thon",
        //   url: "/solving-for-india-hackathon",
        //   id: "header_contest_hackathon",
        // },
        {
          name: "All Contest and Events",
          url: "/events",
          id: "header_contest_allevents",
        },
      ],
    },
    {
      name: "POTD",
      url: "/problem-of-the-day",
      icon: "code",
      id: "header_potd",
    },
  ];

  return <GenericMenu menuItems={menuItems} />;
}
